import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eSucKhoeActionTypeIds, ISucKhoeActionTypes } from "../../action-types/danh-muc/ISucKhoeActionTypes";
import { ISucKhoeReducer } from "../../page-state-model/danh-muc/ISucKhoeReducer";
const iniState: ISucKhoeReducer = {
    status: ePageBaseStatus.is_not_initialization,
    sucKhoes: [],
    sucKhoeVms: []
}
export const sucKhoeReducer = (state: ISucKhoeReducer = iniState, action: ISucKhoeActionTypes): ISucKhoeReducer => {
    switch (action.type) {
        case "SUC_KHOE_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "SUC_KHOE_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                sucKhoeVms: action.payload
            }
        case "SUC_KHOE_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                sucKhoeVms: []
            }
        case "SUC_KHOE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "SUC_KHOE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "SUC_KHOE_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "SUC_KHOE_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "SUC_KHOE_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "SUC_KHOE_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "SUC_KHOE_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "SUC_KHOE_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}